import { RichText } from "@graphcms/rich-text-react-renderer";
import type { RichTextContent } from "@graphcms/rich-text-types";
import { useLoaderData } from "@remix-run/react";

import type { LandingPageLoader } from "~/routes/_pages._index";

import PartnersSlider from "../PartnersSlider/PartnersSlider";
import Pricing from "../Pricing/Pricing";

export interface PricingSectionProps {
  id: string;
  type: string;
  title: string;
  description: {
    raw: RichTextContent;
  };
}

const PricingSection = ({ type, title, description }: PricingSectionProps) => {
  const { products, partners } = useLoaderData<LandingPageLoader>();

  return (
    <section
      id={type}
      className="section-padding-x-large flex flex-col items-center pt-[50px] lg:pt-[110px] xl:px-[14%]"
    >
      <h2 className="h2 mb-[25px] text-center font-semibold">{title}</h2>
      <div
        className={
          "mb-[35px] w-full text-center text-lg md:w-[70%] md:text-xl lg:w-1/2"
        }
      >
        <RichText content={description.raw} />
      </div>
      <div className="w-full">
        <Pricing products={products} />
      </div>
      <PartnersSlider partners={partners} />
    </section>
  );
};

export default PricingSection;
